import { useState, useEffect, useRef } from "react";
import Select from "react-select";
import toast from "react-hot-toast";
import service1 from "../../assets/img/background/service1.png";
import service2 from "../../assets/img/background/service2.png";
import service3 from "../../assets/img/background/service3.png";
import service4 from "../../assets/img/background/service4.png";
import { useMetaDataStore } from "../../store/metadataStore";
import { useMetaStore } from "../../store/data";
import { useNavigate } from "react-router-dom";
import { useJsApiLoader, Autocomplete } from "@react-google-maps/api";
import { LIBRARIES } from "../../components/googleMapsPLaces";
import { API } from "../../utils/axios";

interface LocationState {
  lat: number | undefined;
  lng: number | undefined;
}

export default function SubmitProperty() {
  const autocompleteRef = useRef<google.maps.places.Autocomplete | null>(null);
  const sessionTokenRef =
    useRef<google.maps.places.AutocompleteSessionToken | null>(null);

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.REACT_APP_GOOGLe_API as string,
    libraries: LIBRARIES,
  });

  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const navigate = useNavigate();
  const [businessType, setBusinessType] = useState<number | null>(null);
  const [isLoading, setIsloading] = useState(false);
  const [streetAddress, setStreetAddress] = useState("");
  const [city, setCity] = useState<number | null>(null);
  const [state, setState] = useState<number | null>(null);
  const [zipcode, setZipcode] = useState("");
  const [provinceCode, setProvinceCode] = useState<string | undefined>("");
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [phone, setPhone] = useState("");
  const [phoneNoError, setphoneNoError] = useState("");
  const [authorizedPersonName, setAuthorizedPersonName] = useState("");
  const [authorizedPersonTitle, setAuthorizedPersonTitle] = useState<
    number | null
  >(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [location, setLocation] = useState<LocationState>({ lat: 0, lng: 0 });
  const { states, loading, getCitiesByState } = useMetaDataStore();
  const { roles, businessTypes } = useMetaStore();
  const [isServiceAvailable, setIsServiceAvailable] = useState(true);

  const stateOptions = states.map((st) => ({
    value: st.zone_id,
    label: st.name,
    code: st.code,
  }));

  const cityOptions =
    state !== null
      ? getCitiesByState(state).map((c) => ({
          value: c.city_id,
          label: c.city_name,
        }))
      : [];

  const authorizedPersonTitleType = roles.map((role) => ({
    value: role.id,
    label: role.name,
  }));

  const businessTypeList = businessTypes.map((business) => ({
    value: business.id,
    label: business.name,
  }));

  const normalize = (str: string) =>
    str.toLowerCase().trim().replace(/\s+/g, " ");

  const handlePlacesChanged = () => {
    if (!autocompleteRef.current) return;

    const place = autocompleteRef.current.getPlace();
    if (!place) return;
    // Full formatted address
    const address = place.formatted_address || "";

    // Latitude & Longitude
    const lat = place.geometry?.location?.lat();
    const lng = place.geometry?.location?.lng();

    if (lat && lng) {
      setLocation({ lat, lng });
    }

    // Extract city, state, country
    let google_city = "";
    let state = "";
    let country = "";
    let postal_code = "";

    place.address_components?.forEach((component) => {
      const types = component.types;

      if (types.includes("locality")) {
        google_city = component.long_name;
      }

      // if (types.includes("administrative_area_level_1")) {
      //   state = component.long_name;
      // }

      // if (types.includes("country")) {
      //   country = component.long_name;
      // }

      if (types.includes("postal_code")) {
        postal_code = component.long_name;
        setZipcode(component.long_name);
      }
    });

    const GTAcities = [
      "Toronto",
      "Mississauga",
      "Brampton",
      "Markham",
      "Vaughan",
      "Richmond Hill",
      "Oakville",
      "Burlington",
      "Milton",
      "Ajax",
      "Pickering",
      "Whitby",
      "Oshawa",
      "Newmarket",
      "Aurora",
      "King",
      "Georgina",
      "Halton Hills",
      "North York",
      "Scarborough",
      "Etobicoke",
      "York",
      "East York",
      "Airdrie",
      "Calgary",
      "Chestermere",
      "Edmonton",
      "Lethbridge",
      "Red Deer",
      "Calgary",
      "Hamilton",
      "Kitchener",
      "Waterloo",
      "London",
      "Ottawa",
    ];

    setStreetAddress(address);

    const GTAcitiesSet = new Set(GTAcities.map(normalize));
    const validCity = GTAcitiesSet.has(normalize(google_city));
    if (!validCity) {
      setIsServiceAvailable(false);
      toast.error("We are not available in these area");
      return;
    } else {
      setIsServiceAvailable(true);
    }

    sessionTokenRef.current = new google.maps.places.AutocompleteSessionToken();

    // Start new session
    (autocompleteRef.current as any).sessionToken = sessionTokenRef.current;
  };

  // const getLocation = () => {
  //   if (!navigator.geolocation) {
  //     toast.error("Geolocation is not supported by your browser");
  //     return;
  //   }

  //   navigator.geolocation.getCurrentPosition(
  //     (position: GeolocationPosition) => {
  //       const { latitude, longitude } = position.coords;

  //       if (latitude && longitude) {
  //         setLocation({
  //           lat: latitude,
  //           lng: longitude,
  //         });
  //       }
  //     },
  //     (err: GeolocationPositionError) => {
  //       toast.error(err.message);
  //     },
  //     {
  //       enableHighAccuracy: true,
  //       timeout: 10000,
  //       maximumAge: 0,
  //     }
  //   );
  // };

  const validateEmail = (email: string) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const validatePhone = (phone: string) => {
    const regex = /^[1-9]\d{9}$/;
    return regex.test(phone);
  };

  const handleEmailChange = (e: any) => {
    const value = e.target.value;
    setEmail(value);

    if (value === "") {
      setEmailError("Email is required");
    } else if (!validateEmail(value)) {
      setEmailError("Please enter a valid email address");
    } else {
      setEmailError("");
    }
  };

  const handlePhoneNoChange = (e: any) => {
    const value = e.target.value;
    setPhone(value);

    if (value === "") {
      setphoneNoError("Phone number is required");
    } else if (!validatePhone(value)) {
      setphoneNoError("Please enter a valid 10-digit phone number");
    } else {
      setphoneNoError("");
    }
  };

  const handleMerchantFormSubmit = async () => {
    if (!authorizedPersonName)
      return toast.error("Please fill Authorized person's name");
    if (!authorizedPersonTitle)
      return toast.error("Please fill Authorized person's title");
    if (!businessType) return toast.error("Business type is required.");
    if (!email?.trim()) return toast.error("Email address is required.");
    if (emailError) return toast.error("Invalid email format.");
    if (phoneNoError) return toast.error("Invalid phone number format.");
    if (!phone?.trim()) return toast.error("Phone number is required.");
    if (!streetAddress) return toast.error("Street address is required");
    if (!state) return toast.error("Province/state address is required");
    if (!city) return toast.error("City address is required");
    if (!isServiceAvailable)
      return toast.error("we are not available on mentioned address");
    setIsloading(true);

    try {
      const businessPayload: any = {
        authorizedPersonName,
        authorizedPersonTitle,
        businessType,
        business_email: email,
        business_phone: phone,
        timeZone: userTimeZone,
        streetAddress,
        city,
        state,
        zipcode,
        provinceCode,
        location,
      };

      const { data } = await API.post("/business", businessPayload);
      if (!data.success) {
        toast.error(data.message);
        return;
      }
      if (data.success) {
        if (window.gtag) {
          window.gtag("event", "conversion", {
            send_to: "AW-17685944295/2yFlCOzW370bE0evqPFB",
          });
        }
        navigate(`/business-registration-success?email=${email}`);
      } else {
        console.error("Unexpected status:", data);
      }
    } catch (error) {
      console.error("Error submitting data:", error);
    } finally {
      setIsloading(false);
    }
  };

  // useEffect(() => {
  //   getLocation();
  // }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % 4);
    }, 2500); // 2.5 sec auto slide
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {/* Main Section */}
      <div className="grid grid-cols-1 lg:grid-cols-6 min-h-screen">
        {/* === Left Sidebar / Progress Panel === */}
        <div className="hidden lg:block lg:col-span-2">
          <div className="fixed top-0 left-0 h-screen w-1/3 bg-teal-600 p-16 text-white shadow-2xl flex flex-col">
            <div className="relative w-full overflow-hidden rounded-xl mt-20">
              <div
                className="flex transition-transform duration-700 rounded-xl"
                style={{ transform: `translateX(-${currentSlide * 100}%)` }}
              >
                {[service1, service2, service3, service4].map((img, idx) => (
                  <img
                    key={idx}
                    src={img}
                    className="w-full h-full object-contain flex-shrink-0 rounded-lg"
                  />
                ))}
              </div>

              <div className="mt-2 flex justify-center gap-2">
                {Array.from({ length: 4 }).map((_, idx) => (
                  <button
                    key={idx}
                    onClick={() => setCurrentSlide(idx)}
                    className={`h-2 w-2 rounded-full transition-all ${
                      currentSlide === idx ? "bg-white w-6" : "bg-white/50"
                    }`}
                  ></button>
                ))}
              </div>
            </div>

            <p className="text-teal-50 text-xl mb-12 mt-10">
              We're excited to partner with you. Please complete the following
              steps to finalize your setup.
            </p>
          </div>
        </div>

        <section className="lg:col-span-4 p-4 md:p-10 bg-white">
          <div className="max-w-4xl mx-auto">
            {/* FORM WRAPPER */}
            <div className="bg-white shadow-lg rounded-2xl p-6 md:p-10 border border-gray-100 space-y-10">
              {/* Section 1: Account Holder */}
              <div>
                <h2 className="text-2xl font-semibold text-gray-800 mb-6">
                  Authorized Representative
                </h2>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="flex flex-col gap-2">
                    <label className="text-sm font-medium text-gray-700">
                      Full Name <span className="text-red-600">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Enter full name"
                      value={authorizedPersonName}
                      onChange={(e) => setAuthorizedPersonName(e.target.value)}
                      className="w-full rounded-md border border-gray-300 px-3 py-2 focus:ring-indigo-500 focus:border-indigo-500"
                    />
                  </div>

                  <div className="flex flex-col gap-2">
                    <label className="text-sm font-medium text-gray-700">
                      Role / Title <span className="text-red-600">*</span>
                    </label>
                    <Select
                      options={authorizedPersonTitleType}
                      classNamePrefix="react-select"
                      placeholder="Select title"
                      value={authorizedPersonTitleType.find(
                        (o) => o.value === authorizedPersonTitle,
                      )}
                      onChange={(sel) => {
                        if (sel) setAuthorizedPersonTitle(sel?.value);
                      }}
                    />
                  </div>
                </div>
              </div>

              <hr className="border-gray-200" />

              {/* Section 2: Business Details */}
              <div>
                <h2 className="text-2xl font-semibold text-gray-800 mb-6">
                  Business Details
                </h2>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {/* Business Type */}
                  <div className="flex flex-col gap-2">
                    <label className="text-sm font-medium text-gray-700">
                      Business Type <span className="text-red-600">*</span>
                    </label>
                    <Select
                      options={businessTypeList}
                      classNamePrefix="react-select"
                      placeholder="Select type"
                      value={businessTypeList.find(
                        (o) => o.value === businessType,
                      )}
                      onChange={(sel) => {
                        if (sel) setBusinessType(sel?.value);
                      }}
                    />
                  </div>

                  {/* Email */}
                  <div className="flex flex-col gap-2">
                    <label className="text-sm font-medium text-gray-700">
                      Email Address <span className="text-red-600">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Enter email"
                      value={email}
                      onChange={handleEmailChange}
                      className={`w-full rounded-md border px-3 py-2 focus:ring-indigo-500 focus:border-indigo-500 ${
                        emailError ? "border-red-500" : "border-gray-300"
                      }`}
                    />
                    {emailError && (
                      <p className="text-red-600 text-sm">{emailError}</p>
                    )}
                  </div>

                  {/* Phone */}
                  <div className="flex flex-col gap-2">
                    <label className="text-sm font-medium text-gray-700">
                      Phone Number <span className="text-red-600">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Enter phone number"
                      value={phone}
                      onChange={handlePhoneNoChange}
                      className={`w-full rounded-md border px-3 py-2 focus:ring-indigo-500 focus:border-indigo-500 ${
                        phoneNoError ? "border-red-500" : "border-gray-300"
                      }`}
                    />
                    {phoneNoError && (
                      <p className="text-red-600 text-sm">{phoneNoError}</p>
                    )}
                  </div>
                </div>
              </div>

              <hr className="border-gray-200" />

              <div>
                <h2 className="text-2xl font-semibold text-gray-800 mb-6">
                  Business Address
                </h2>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="flex flex-col gap-2">
                    <label className="text-sm font-medium text-gray-700">
                      Province / State <span className="text-red-600">*</span>
                    </label>

                    <Select
                      options={stateOptions}
                      classNamePrefix="react-select"
                      placeholder="select province"
                      value={stateOptions.find((o) => o.value === state)}
                      onChange={(sel) => {
                        if (sel) {
                          setState(sel.value);
                          setProvinceCode(sel.code);
                          setCity(null);
                        }
                      }}
                    />
                  </div>

                  <div className="flex flex-col gap-2">
                    <label className="text-sm font-medium text-gray-700">
                      City <span className="text-red-600">*</span>
                    </label>
                    <Select
                      options={cityOptions}
                      classNamePrefix="react-select"
                      isDisabled={!state}
                      placeholder={
                        state ? "Select city" : "select province/state first"
                      }
                      value={cityOptions.find((o) => o.value === city) || null}
                      onChange={(sel) => {
                        if (sel) {
                          setCity(sel?.value);
                        }
                      }}
                    />
                  </div>

                  <div className="flex flex-col gap-2">
                    <label className="text-sm font-medium text-gray-700">
                      Street Address <span className="text-red-600">*</span>
                    </label>
                    {isLoaded && (
                      <Autocomplete
                        onLoad={(autocomplete) => {
                          autocompleteRef.current = autocomplete;

                          sessionTokenRef.current =
                            new google.maps.places.AutocompleteSessionToken();

                          // Set options WITHOUT sessionToken
                          autocomplete.setOptions({
                            componentRestrictions: { country: "ca" },
                            // types: ["address"],
                          });

                          // 👇 Set sessionToken separately
                          (autocomplete as any).sessionToken =
                            sessionTokenRef.current;
                        }}
                        onPlaceChanged={handlePlacesChanged}
                      >
                        <input
                          type="text"
                          // placeholder="Enter street address"
                          disabled={!state || !city}
                          placeholder={
                            !state
                              ? "Please select province first"
                              : !city
                                ? "Please select city first"
                                : "Start typing your location"
                          }
                          className="w-full rounded-md border border-gray-300 px-3 py-2 focus:ring-indigo-500 focus:border-indigo-500"
                          value={streetAddress}
                          onChange={(e) => setStreetAddress(e.target.value)}
                        />
                      </Autocomplete>
                    )}
                  </div>
                </div>
              </div>

              {/* Submit Button */}
              <div className="flex justify-end pt-4">
                <button
                  onClick={handleMerchantFormSubmit}
                  disabled={isLoading}
                  className="bg-indigo-600 hover:bg-indigo-700 transition text-white font-medium px-4 py-2 rounded-lg shadow-md"
                >
                  {isLoading ? "Submitting..." : "Submit"}
                </button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
